export default "__VITE_ASSET__CCvnOza0__"